function Card({ title, value, icon, accent = 'bg-red-500', iconBg = 'bg-red-100', iconColor = 'text-red-600' }) {
  return (
    <div className="relative overflow-hidden rounded-2xl border border-gray-100 bg-white p-6 shadow-sm transition hover:-translate-y-0.5 hover:shadow-md">
      <div className={`absolute -right-8 -top-10 h-24 w-24 rounded-full ${iconBg} opacity-50`} />
      <div className="relative z-10 flex items-center justify-between">
        <div className="flex-1">
          <div className="text-[11px] text-gray-500 uppercase tracking-[0.2em] font-semibold mb-2">
            {title}
          </div>
          <div className="text-3xl font-bold text-gray-900">{value}</div>
          <div className={`mt-3 h-1 w-10 rounded-full ${accent}`} />
        </div>
        <div className={`${iconBg} ${iconColor} p-4 rounded-2xl border border-white/60 shadow-sm`}>
          {icon}
        </div>
      </div>
    </div>
  );
}

export default function ClientesSinPrestamoKPICards({ estadisticas }) {
  const { 
    total_clientes_sin_prestamo_activo = 0, 
    con_historial_prestamos = 0, 
    sin_registro_prestamos = 0 
  } = estadisticas || {};

  return (
    <section className="mb-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <Card 
        title="Clientes sin Préstamo Activo" 
        value={total_clientes_sin_prestamo_activo}
        accent="bg-red-500"
        iconBg="bg-red-100"
        iconColor="text-red-600"
        icon={
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        }
      />
      
      <Card 
        title="Con Historial de Préstamos" 
        value={con_historial_prestamos}
        accent="bg-amber-500"
        iconBg="bg-yellow-100"
        iconColor="text-yellow-600"
        icon={
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }
      />
      
      <Card 
        title="Sin Registro de Préstamos" 
        value={sin_registro_prestamos}
        accent="bg-slate-500"
        iconBg="bg-gray-100"
        iconColor="text-gray-600"
        icon={
          <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        }
      />
    </section>
  );
}
